import React, { useCallback } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import PaymentStatusModal from "./PaymentStatusModal";
import { emitPaymentsChanged } from "../../../services/paymentsEvents";
import { getPaymentStatusDeduped } from "../../../services/paymentStatusPoll";
import {
  isPaymentReturnUrl,
  stripPaymentQueryKeys,
} from "../../../utils/paymentCallbackParams";

const PaymentCallbackOverlay: React.FC = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Pending ZainCash wallet top-ups are included inside isPaymentReturnUrl.
  const isOpen = isPaymentReturnUrl(searchParams);

  const handleClose = useCallback((outcome?: "review" | "history" | "step1") => {
    const zainWalletPending = localStorage.getItem("lastZainCashWalletTopUp") === "1";
    const pendingTxId = (localStorage.getItem("lastZainCashTransactionId") ?? "").trim();

    if (zainWalletPending && pendingTxId) {
      void getPaymentStatusDeduped("ZainCash", pendingTxId).catch(() => {});
    }

    const next = stripPaymentQueryKeys(new URLSearchParams(location.search));
    const goWallet =
      searchParams.get("returnTo") === "wallet" || zainWalletPending;
    localStorage.removeItem("lastZainCashWalletTopUp");

    emitPaymentsChanged();

    if (outcome === "review") {
      navigate(`/saleOrder?checkout=${Date.now()}`, { replace: true });
      return;
    }
    if (outcome === "step1") {
      navigate("/saleOrder", { replace: true });
      return;
    }

    if (goWallet) {
      navigate("/walletBalance", { replace: true });
      return;
    }

    if (searchParams.get("returnTo") === "dashboard") {
      const qs = next.toString();
      navigate(qs ? `/dashboard?${qs}` : "/dashboard", { replace: true });
      return;
    }

    next.set("tab", "OrderHistory");
    navigate(`/saleOrder?${next.toString()}`, { replace: true });
  }, [location.search, navigate, searchParams]);

  if (!isOpen) return null;

  return <PaymentStatusModal open={true} onClose={handleClose} />;
};

export default PaymentCallbackOverlay;
